module.exports = __webpack_public_path__ + "static/media/High.ce40073f.svg";